angular.module('picmonic-common').directive('plsPricingLink', [
  'UserService',
  'MarketOptionsConfig',
  '$state',
  '$cookies',
  '$modal',
  'ngBowser',
  '$rootScope',
  'FreePremiumTrialModal',
  'SplitTestService',
  function (UserService, MarketOptionsConfig, $state, $cookies, $modal, ngBowser, $rootScope, FreePremiumTrialModal) {
    return {
      restrict: 'A',
      scope: {
        plsPricingLink: '=',
      },
      link: function (scope, element, attr) {
        element.bind('click', function () {
          scope.$apply(function () {
            if (typeof scope.plsPricingLink === 'function') {
              lead = scope.plsPricingLink();
            } else {
              lead = parseInt(scope.plsPricingLink || UserService.user.lead || $cookies.get('pls_user_lead', 100), 10);
            }

            var market = MarketOptionsConfig.getMarketById(lead);

            var url, title;

            if (typeof atlasEvent !== 'undefined') {
              atlasEvent('click', 'upgrade to premium access');
            }

            var excludedPseudoMarkets = [108, 114, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511];

            if (!market.slug) {
              url = '/store';
              title = 'Checkout';
            } else if (market.is_pseudo && excludedPseudoMarkets.includes(market.id) === false) {
              url = '/pricing/' + market.slug;

              if (market.picmonic_partner) {
                title = market.name + ' - Pricing';
              } else {
                title = 'Picmonic for ' + market.name + ' - Pricing';
              }
            } else {
              url = '/store/' + market.slug + '?upgrade=1&popular=1';

              title = 'Checkout';

              if ($rootScope.embed) {
                url = '/pricing/' + market.slug;
                title = 'Picmonic for ' + market.name + ' - Pricing';
              } else if (UserService.shouldShowFPTCta() && excludedPseudoMarkets.indexOf(market.id) === -1) {
                url += '&premium_trial=1';
              }

              try {
                urlParams = new URLSearchParams(window.location.search);
                promo_code = urlParams.get('promo_code');

                if (promo_code) {
                  url += '&promo_code=' + promo_code;
                }
              } catch ($e) {
                // do nothing
              }
            }

            if ($rootScope.embed) {
              url +=
                (url.indexOf('?') === -1 ? '?' : '&') +
                (UserService.getApiKey() ? 'api_key=' + UserService.getApiKey() : '');
              window.open(url);
              return;
            }

            if (ngBowser.isDesktop()) {
              var modal = $modal.open({
                windowClass: 'pls-how-it-works-modal',
                backdropClass: 'above-nav',
                keyboard: false,
                backdrop: 'static',
                size: 'xl',
                template:
                  '<div class="modal-header p-b-6">\
                                            <i class="material-icons pull-right pls-wet-cement" role="button" tabindex="0" ng-click="$close()">close</i>\
                                            <span class="modal-header-title pls-pricing-link-modal-header-title">' +
                  title +
                  '</span>\
                                        </div>\
                                        <div class="modal-body" style="padding-top:63px;overflow-y: hidden;"><iframe id="pricing_modal" src="' +
                  url +
                  '" style="width:100%; min-height:85vh; height:100%; border:none; margin-bottom:-4px;"></iframe>',
              });

              // Refresh the page on modal close if we set refresh on the thank you page.
              modal.result.finally(function () {
                if (window.refresh) {
                  location.reload();
                }

                if (window.picmonic_redirect) {
                  location = window.picmonic_redirect;
                }
              });
            } else {
              window.location = url;
            }
          });
        });
      },
    };
  },
]);
